import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { HighlightedRecommendations } from '../HighlightedRecommendations/HighlightedRecommendations';
import { type RecommendationsProps } from '../Recommendations.types';
import { FRIENDLY_SELLER_GIF_PATH, SOURCE_COMPONENT, BASE_KEY } from './FtbFriendly.constants';
import './styles.scss';

export const FtbFriendlyRecommendations: React.FC<RecommendationsProps> = ({
    listings,
    gigs = [],
    isLoading = false,
    isNarrowView = false,
}) => (
    <HighlightedRecommendations
        className="ftb-friendly-recommendations"
        title={<I18n k={`${BASE_KEY}.title`} />}
        description={<I18n k={`${BASE_KEY}.description`} />}
        listings={listings}
        gigs={gigs}
        componentName={SOURCE_COMPONENT}
        iconPath={FRIENDLY_SELLER_GIF_PATH}
        isLoading={isLoading}
        isNarrowView={isNarrowView}
    />
);
